import React from 'react'
import PropTypes from 'prop-types'
import AloDropdown from '../aloDropdown/AloDropdown'
import ElementHeightAnimator from '../elementHeightAnimator/ElementHeightAnimator'
import classNames from 'classnames'
import './FilterRowDropdown.scss'
import FilterRowDropdownItem from './FilterRowDropdownItem'

/**
 * - Passing renderDropdownItemTemplate prop will create a standard menu with links
 * - Passing renderDropdownContent allows you to create a custom layout like the slider found in Class Finder.
 * @param {*} props
 */
class FilterRowDropdown extends React.Component {
  constructor (props) {
    super(props)

    this.slideToFilterRow = this.slideToFilterRow.bind(this)
    this.renderContent = this.renderContent.bind(this)
  }

  getIndex(tab) {
    return tab === 'completed' ? 0 :
      tab==='classes'? 1: 2
  }

  slideToFilterRow() {
    // checking the tab here to identify which tab in myPractice page.
    // 0 in below line assumes component is called from class-finder or series-finder
    const index= this.props.tab ? this.getIndex(this.props.tab): 0
    const filterRow = document.getElementsByClassName('FilterMetaLayout')[index]
    if (filterRow && !filterRow.classList.contains('FilterMetaLayout--fixed')) {
      const filterRowTop =
        filterRow.getBoundingClientRect().top +
        document.documentElement.scrollTop -
        100
      window.scrollTo({
        top: filterRowTop,
        behavior: 'smooth'
      })
    }
  }

  renderContent (dropdownHasSubItems) {
    if (dropdownHasSubItems) {
      return this.renderWithHeaders()
    }
    let allOption
    if (this.props.onCheckAll) {
      allOption = (
        <FilterRowDropdownItem
          active={this.props.allOptionsSelected}
          handleItemClick={this.props.onCheckAll}
          label={`All ${this.props.filterName}`}
        />
      )
    }
    const content = this.renderWithNoSubItems()
    return (
      <React.Fragment>
        {allOption}
        {content}
      </React.Fragment>
    )
  }

  renderWithHeaders () {
    return this.props.dropdownOptions.map((parentOption, idx) => {
      const subItems = parentOption[this.props.subItems] || []
      return (
        <div className='FilterRowDropdown__optionCol' key={idx}>
          {this.props.renderDropdownItemTemplate({
            option: parentOption,
            header: true
          })}
          <div className='FilterRowDropdown__optionSubItems'>
            {subItems.map((childOption, index) => (
              <React.Fragment key={index}>
                {this.props.renderDropdownItemTemplate({
                  option: childOption,
                  parent: parentOption
                })}
              </React.Fragment>
            ))}
          </div>
        </div>
      )
    })
  }

  renderWithNoSubItems () {
    if (this.props.dropdownOptions) {
      return (
        <>
          {this.props.filterDesc ? <p>{this.props.filterDesc}</p>: null}
          {this.props.dropdownOptions.map((option, idx) => (
            <React.Fragment key={idx}>
              {this.props.renderDropdownItemTemplate({ option })}
          </React.Fragment>
          ))}
        </>
      )
    } else if (this.props.renderDropdownContent) {
      return this.props.renderDropdownContent()
    }
  }

  buildDropdownStyles () {
    let styles = ''
    if (this.props.numDropdownCols) {
      for (const screenWidth in this.props.numDropdownCols) {
        const numCols = this.props.numDropdownCols[screenWidth]
        const numRows = Math.ceil(this.props.dropdownOptions.length / numCols)
        
        const style = `
            @media(min-width: ${screenWidth}px) {
              ul.dropdown-menu {
                grid-template-columns: repeat(${numCols}, auto);
                grid-template-rows: repeat(${numRows}, auto);
              }
            }\n`
        styles = styles.concat(style)
      }
    }

    return styles
  }

  render () {
    const dropdownHasSubItems = !!this.props.subItems
    let dropdownContent = this.renderContent(dropdownHasSubItems)

    const dropdownClassNames = ['FilterDropdownSet__display dropdown'].concat(
      this.props.additionalClassNames
    )

    const filterRowDropdownClass = classNames(
      'FilterRowDropdown',
      'filter-dropdown-slide',
      {
        'FilterRowDropdown--gridItems':
          !!this.props.numDropdownCols && !dropdownHasSubItems,
        'FilterRowDropdown--subItems': dropdownHasSubItems
      }
    )

    let dropdown = (
      <AloDropdown
        additionalClasses={dropdownClassNames}
        additionalOpenClass={this.props.additionalOpenClass}
        open={this.props.open}
        includeArrowButton={false}
        dropdownStyles={this.buildDropdownStyles()}
        ref={this.filterDropdown}
      >
        {dropdownContent}
        {this.props.bottomItems?.()}
      </AloDropdown>
    )

    if (!this.props.noSlideAnimation) {
      dropdown = (
        <ElementHeightAnimator
          sliderClass={filterRowDropdownClass}
          open={this.props.open}
          onAfterClose={this.props.onAfterClose}
          onAfterOpen={() => {
            this.props.onAfterOpen()
            this.slideToFilterRow()
          }}
        >
          {dropdown}
        </ElementHeightAnimator>
      )
    }

    return dropdown
  }
}

FilterRowDropdown.defaultProps = {
  additionalClassNames: [],
  onAfterClose: () => {},
  onAfterOpen: () => {}
}

FilterRowDropdown.propTypes = {
  additionalClassNames: PropTypes.array,
  additionalOpenClass: PropTypes.string,
  allOptionsSelected: PropTypes.bool,
  dropdownOptions: PropTypes.array,
  filterName: PropTypes.string,
  noSlideAnimation: PropTypes.bool,
  numDropdownCols: PropTypes.object,
  onAfterClose: PropTypes.func,
  onAfterOpen: PropTypes.func,
  onCheckAll: PropTypes.func,
  open: PropTypes.bool,
  renderDropdownItemTemplate: PropTypes.func,
  renderDropdownContent: PropTypes.func,
  bottomItems: PropTypes.func,
  subItems: PropTypes.string
}

export default FilterRowDropdown
